import React from "react";
import "./Footer.css";
import {
  FaTwitter,
  FaFacebookF,
  FaGlobe,
  FaLinkedinIn,
} from "react-icons/fa";
import { Link } from "react-router-dom";

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* LEFT */}
        <div className="footer-col">
          <h2>IEEE 2027</h2>

          <p>
            The platform serves as a premier platform for collaboration and
            innovation at the intersection of quantum science and modern
            communication engineering.
          </p>
        </div>


        {/* MIDDLE */}
        <div className="footer-col">
          <h3>Quick Links</h3>

          <ul>
            <li>
              <Link to="/about">About</Link>
            </li>

            <li>
              <Link to="/iqicsa#call-for-paper">
                Call for Papers
              </Link>
            </li>

            <li>
              <Link to="/iqicsa#important-dates">
                Important Dates
              </Link>
            </li>

            <li>
              <Link to="/author#guidelines">
                Author's Guidelines
              </Link>
            </li>

            <li>
              <Link to="/author#registration">
                Registration
              </Link>
            </li>

            <li>
              <Link to="/committee">
                Committee
              </Link>
            </li>

            <li>
              <Link to="/advisoryBoard">
                Advisory Board
              </Link>
            </li>

          </ul>
        </div>


        {/* RIGHT */}
        <div className="footer-col">
          <h3>Contact Us</h3>

          <p>
            Army Institute of Technology, Pune, India
          </p>

          <p>
            hodcomp@aitpune.edu.in
          </p>

          <p>
            Phone:  8956018951 [EXT:2300]
          </p>
        </div>

      </div>


      {/* =====================================================
          MICROSOFT CMT ACKNOWLEDGMENT
      ===================================================== */}

      {/* <div className="cmt-section">

        <p className="cmt-acknowledgment">
          The Microsoft CMT service was used for managing the peer-reviewing
          process for this conference. This service was provided for free by
          Microsoft and they bore all expenses, including costs for Azure
          cloud services as well as for software development and support.
        </p>

      </div> */}


      <hr />


      {/* FOOTER BOTTOM */}
      <div className="footer-bottom">

        <p>
          © 2027 Department of Computer Engineering. All Rights Reserved.
        </p>

        <div className="socials">

          <a
            href="https://x.com/ait_pune"
            target="_blank"
            rel="noreferrer"
          >
            <FaTwitter />
          </a>

          <a
            href="https://www.aitpune.com/"
            target="_blank"
            rel="noreferrer"
          >
            <FaGlobe />
          </a>

          <a
            href="https://www.facebook.com/aitpune/"
            target="_blank"
            rel="noreferrer"
          >
            <FaFacebookF />
          </a>

          <a
            href="https://www.linkedin.com/school/army-institute-of-technology-ait-pune/posts/?feedView=all"
            target="_blank"
            rel="noreferrer"
          >
            <FaLinkedinIn />
          </a>

        </div>

      </div>

    </footer>
  );
}

export default Footer;